/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FinancialGroupLightResponse } from './FinancialGroupLightResponse';
import {
    FinancialGroupLightResponseFromJSON,
    FinancialGroupLightResponseFromJSONTyped,
    FinancialGroupLightResponseToJSON,
    FinancialGroupLightResponseToJSONTyped,
} from './FinancialGroupLightResponse';
import type { InvoiceSearchItemResponse } from './InvoiceSearchItemResponse';
import {
    InvoiceSearchItemResponseFromJSON,
    InvoiceSearchItemResponseFromJSONTyped,
    InvoiceSearchItemResponseToJSON,
    InvoiceSearchItemResponseToJSONTyped,
} from './InvoiceSearchItemResponse';

/**
 * 
 * @export
 * @interface InvoiceSearchGroupResponse
 */
export interface InvoiceSearchGroupResponse {
    /**
     * 
     * @type {FinancialGroupLightResponse}
     * @memberof InvoiceSearchGroupResponse
     */
    financialGroup?: FinancialGroupLightResponse;
    /**
     * 
     * @type {Array<InvoiceSearchItemResponse>}
     * @memberof InvoiceSearchGroupResponse
     */
    invoices?: Array<InvoiceSearchItemResponse>;
}

/**
 * Check if a given object implements the InvoiceSearchGroupResponse interface.
 */
export function instanceOfInvoiceSearchGroupResponse(value: object): value is InvoiceSearchGroupResponse {
    return true;
}

export function InvoiceSearchGroupResponseFromJSON(json: any): InvoiceSearchGroupResponse {
    return InvoiceSearchGroupResponseFromJSONTyped(json, false);
}

export function InvoiceSearchGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceSearchGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'financialGroup': json['financialGroup'] == null ? undefined : FinancialGroupLightResponseFromJSON(json['financialGroup']),
        'invoices': json['invoices'] == null ? undefined : ((json['invoices'] as Array<any>).map(InvoiceSearchItemResponseFromJSON)),
    };
}

export function InvoiceSearchGroupResponseToJSON(json: any): InvoiceSearchGroupResponse {
    return InvoiceSearchGroupResponseToJSONTyped(json, false);
}

export function InvoiceSearchGroupResponseToJSONTyped(value?: InvoiceSearchGroupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'financialGroup': FinancialGroupLightResponseToJSON(value['financialGroup']),
        'invoices': value['invoices'] == null ? undefined : ((value['invoices'] as Array<any>).map(InvoiceSearchItemResponseToJSON)),
    };
}

